package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HealthLogDto(
    @SerialName("id") val id: String,
    @SerialName(FIELD_DATE) val date: Timestamp,
    @SerialName("answers") val answers: List<HealthLogEntryDto>,
) {
    companion object {
        const val FIELD_DATE = "timestamp"
    }
}

@Serializable
data class HealthLogEntryDto(
    @SerialName("questionId") val questionId: String,
    @SerialName("answers") val answers: List<HealthLogAnswerDto>,
)

@Serializable
data class HealthLogAnswerDto(
    @SerialName("answerId") val answerId: String,
    @SerialName("weight") val weight: Int,
)